import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { CHECK_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const CheckIcon = (props: IconGlyphProps) => <Icon {...props} glyph={CHECK_GLYPH} />;
